'use client';

import { FC, memo } from 'react';
import { Button } from '@mui/material';
import { useTranslations } from 'next-intl';
import {
  CardFooter,
  NotChangedBadge,
} from '@/features/pages/profile/wlas-widget/components/WlasTabsPanel/tabs/configuration/styled';

interface WlasFooterActionsProps {
  isDirty: boolean;
  isPreviewDirty: boolean;
  isSaving: boolean;
  onSave: () => void;
  onPreview: () => void;
  onReset: () => void;
}

export const WlasFooterActions: FC<WlasFooterActionsProps> = memo(
  ({ isDirty, isPreviewDirty, isSaving, onSave, onPreview, onReset }) => {
    const t = useTranslations('wlasWidget');

    return (
      <CardFooter>
        <Button
          variant="secondary"
          onClick={onSave}
          disabled={!isDirty || isSaving}
          sx={{ height: '38px', px: '18px' }}
        >
          {t('save')}
        </Button>
        <Button
          variant="outline-secondary"
          onClick={onPreview}
          disabled={!isPreviewDirty}
          sx={{ height: '38px', px: '18px', '&.Mui-disabled': { border: 'none' } }}
        >
          {t('applyPreview')}
        </Button>
        <Button
          variant="text"
          onClick={onReset}
          disabled={!isDirty}
          sx={{ height: '38px', px: '18px' }}
        >
          {t('resetDefaults')}
        </Button>
        <NotChangedBadge role="status" aria-live="polite">
          {isPreviewDirty ? t('previewOutdated') : t('previewUpToDate')}
        </NotChangedBadge>
      </CardFooter>
    );
  },
);
WlasFooterActions.displayName = 'WlasFooterActions';
